import { session, socket } from 'lib_ui-services';

const _p = {
    session: { clearSessionData: session.clearSessionData },
    socket: { disconnect: socket.disconnect }
};

export default {
    verb: 'doingUpdate',
    namespace: 'application',
    relation: 'runtime',
    type: 'clearSession',
    prerequisites: [],
    description: 'Clears the current user session data, but does not logout (triggers load of selectTenant page)',
    //this is the actual logic:
    logic: removeTenant,
    _private: _p
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @returns {Promise<void>}
 */
async function removeTenant() {
    // disconnect first to avoid additional data coming in after we cleared the session
    await _p.socket.disconnect();
    // then clear the session (but do not logout) so we can cleanly connect to a new tenant
    await _p.session.clearSessionData();
}
